// // Modal.js
// import React from 'react';

// const Modal = ({ name, birthDate, setName, setBirthDate, setShowModal }) => {
//   return (
//     <div className="modal">
//       <div className="modal-content">
//         <h2>Enter Your Details</h2>
//         <input
//           type="text"
//           value={name}
//           onChange={setName}
//           placeholder="Enter your name"
//         />
//         <input
//           type="date"
//           value={birthDate.toISOString().split("T")[0]}
//           onChange={setBirthDate}
//         />
//         <button onClick={() => setShowModal(false)}>Close</button>
//       </div>
//     </div>
//   );
// };

// export default Modal;


// Modal.js
// import React from 'react';
// import './Modal.css'

// const Modal = ({ name, birthDate, setName, setBirthDate, setShowModal }) => {
//   return (
//     <div className="modal-overlay">
//       <div className="modal-content">
//         <h2 className="modal-title">Enter Your Details</h2>
//         <input
//           type="text"
//           value={name}
//           onChange={setName}
//           placeholder="Enter your name"
//           className="modal-input"
//         />
//         <input
//           type="date"
//           value={birthDate.toISOString().split("T")[0]}
//           onChange={setBirthDate}
//           className="modal-input"
//         />
//         <button onClick={() => setShowModal(false)} className="modal-button">Close</button>
//       </div>
//     </div>
//   );
// };

// export default Modal;



// import React from 'react';
// import './Modal.css';

// const Modal = ({ name, birthDate, setName, setBirthDate, setShowModal }) => {
//   // Function to handle clicking outside the modal to close it
//   const handleOverlayClick = (e) => {
//     if (e.target.className === 'modal-overlay') {
//       setShowModal(false);
//     }
//   };

//   return (
//     <div className="modal-overlay" onClick={handleOverlayClick}>
//       <div className="modal-content" role="dialog" aria-labelledby="modal-title" aria-modal="true">
//         <h2 id="modal-title" className="modal-title">Enter Your Details</h2>
//         <input
//           type="text"
//           value={name}
//           onChange={(e) => setName(e.target.value)}
//           placeholder="Enter your name"
//           className="modal-input"
//           aria-label="Name"
//         />
//         <input
//           type="date"
//           value={birthDate.toISOString().split("T")[0]}
//           onChange={(e) => setBirthDate(e.target.value)}
//           className="modal-input"
//           aria-label="Birth Date"
//         />
//         <button onClick={() => setShowModal(false)} className="modal-button">Close</button>
//       </div>
//     </div>
//   );
// };

// export default Modal;




// // Modal.js
// import React from 'react';

// const Modal = ({ name, birthDate, setName, setBirthDate, setShowModal }) => {
//   return (
//     <div className="modal">
//       <div className="modal-content">
//         <h2>Enter Your Details</h2>
//         <input
//           type="text"
//           value={name}
//           onChange={setName}
//           placeholder="Enter your name"
//         />
//         <input
//           type="date"
//           value={birthDate.toISOString().split("T")[0]}
//           onChange={setBirthDate}
//         />
//         <button onClick={() => setShowModal(false)}>Close</button>
//       </div>
//     </div>
//   );
// };

// export default Modal;


// Modal.js
import React from 'react';
import './Modal.css'

const Modal = ({ name, birthDate, setName, setBirthDate, setShowModal }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2 className="modal-title">Enter Your Details</h2>
        <input
          type="text"
          value={name}
          onChange={setName}
          placeholder="Enter your name"
          className="modal-input"
        />
        <input
          type="date"
          value={birthDate.toISOString().split("T")[0]}
          onChange={setBirthDate}
          className="modal-input"
        />
        <button onClick={() => setShowModal(false)} className="modal-button">Close</button>
      </div>
    </div>
  );
};

export default Modal;